/**
 * CART DELIVERY — V3.3 (DROP-IN) — TEST BUILD (COMPRESSED)
 * Same behavior as your current script (incl. Calendar offset = 2 days, phone, greeting, valentine, reload guard),
 * but with fixes to remove the "delay" / duplicate triggers:
 * ✅ Watcher suppression + ignore watcher while datepicker open
 * ✅ UI updates instantly on date change (no waiting for /cart/update.js)
 * ✅ De-dupe bursts (onSelect + watcher + fallback click)
 * ✅ Valentine's Day blocker - auto-reloads page when Feb 14 selected with incompatible cart
 */

window.dataLayer = window.dataLayer || [];

/* ================= BOOT VISUAL SHIELD (ADDED) =================
   Purpose: Prevent ANY delivery UI from rendering until
   the system reaches a stable state.
   This does NOT block logic — only visibility.
================================================================ */

(function () {
  if (window.__CD_BOOT_SHIELD__) return;
  window.__CD_BOOT_SHIELD__ = true;

  document.documentElement.classList.add('cd-booting');

  const style = document.createElement('style');
  style.id = 'cd-boot-style';
  style.textContent = `
    .cd-booting #delivery-option,
    .cd-booting .delivery-options-section {
      visibility: hidden !important;
    }
  `;
  document.head.appendChild(style);
})();


(function () {
  if (window.CartDeliveryLoggerV3) return;
  window.CartDeliveryLoggerV3 = true;

    /* ================= BOOT STATE (ADDED) ================= */
  let __cdBootComplete = false;


  const CONFIG = {
    TZ: 'Asia/Dubai',
    HOLIDAYS: [],
    GENERAL_CUTOFF: '20:00',
    EXPRESS_WINDOW: { start: '10:00', end: '15:00' },
    TODAY_SLOTS: { MORNING_HIDE_AT: '20:00', EVENING_HIDE_AT: '20:00', MIDNIGHT_HIDE_AT: '17:00' },
    EMIRATES: {
      DU: { name: 'Dubai' },
      AZ: { name: 'Abu Dhabi', sundayCutoff: '12:30', otherCutoff: '16:00' },
      AI: { name: 'Al Ain', blockAfterHour: 12 },
      SH: { name: 'Sharjah', blockAfterHour: 14 },
      AJ: { name: 'Ajman' },
      FU: { name: 'Fujairah' },
      RK: { name: 'Ras al-Khaimah' },
      UQ: { name: 'Umm al-Quwain' }
    },
    CALENDAR_DEFAULT_OFFSET_DAYS: 2,
    CAMPAIGNS: {
      VALENTINE: {
        enabled: true,
        dates: ['13-02-2026','14-02-2026'],
        emirates: ['DU'],
        collectionIds: new Set(['268745867351' ,'266284007511']),
        optionSelector: '.dubai-options .valentine-delivery[data-campaign="valentine"]',
        exclusiveInDubai: true
      }
    }
  };

  const UNWANTED_KEYS = ['Delivery Date', 'sender-phone:', 'Send as Anonymous?:'];
  window.CONFIG = window.CONFIG || CONFIG;

  function track(event, data = {}) {
    if (true) return; // analytics disabled for production stabilization
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event, ...data }); } catch (e) {}
    try { console.info(`[CD-analytics] ${event}`, data); } catch (e) {}
  }

  const hasMomentTZ = () => (typeof moment !== 'undefined' && typeof moment.tz === 'function');
  function dubaiNowFallbackDate() {
    try { return new Date(new Date().toLocaleString('en-US', { timeZone: CONFIG.TZ })); }
    catch { return new Date(); }
  }
  (function assertTimezone() {
    if (!hasMomentTZ()) console.warn('[CartDelivery][TZ] moment-timezone not detected. Using Intl/UTC+4 fallback for Asia/Dubai.');
  })();

  const nowDubai = () => (hasMomentTZ() ? moment.tz(CONFIG.TZ) : moment(dubaiNowFallbackDate()));
  const fmtDMY = (m) => (hasMomentTZ() ? m.tz(CONFIG.TZ) : m).format('DD-MM-YYYY');
  const parseDMY = (s) => {
    if (hasMomentTZ()) return moment.tz(s, 'DD-MM-YYYY', true, CONFIG.TZ);
    const m = /^(\d{2})-(\d{2})-(\d{4})$/.exec(String(s) || '');
    if (!m) return moment.invalid();
    const dd = parseInt(m[1], 10), MM = parseInt(m[2], 10) - 1, yyyy = parseInt(m[3], 10);
    const utcMs = Date.UTC(yyyy, MM, dd, 0, 0, 0);
    const dubaiMs = utcMs + (4 * 60 * 60 * 1000);
    return moment(new Date(dubaiMs));
  };
  const sameDay = (a, b) => fmtDMY(a) === fmtDMY(b);
  const timeGE = (a, b) => a >= b;
  const timeLT = (a, b) => a < b;

  const q = (sel, root = document) => root.querySelector(sel);
  const qa = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const emirateName = (code) => (CONFIG.EMIRATES[code]?.name || 'Dubai');
  const selectedEmirateCode = () => (q('#Emirate')?.value || 'DU');

  const slots = () => ({
    morning: q('.morning-delivery') || q('.standard-delivery'),
    evening: q('.evening-delivery'),
    express: q('.today-only') || q('.express'),
    midnight: q('.midnight-option')
  });

  const isHoliday = (dmy) => CONFIG.HOLIDAYS.includes(dmy);
  const isDmy = (v) => /^\d{2}-\d{2}-\d{4}$/.test(String(v || '').trim());
  function isDatepickerOpen() {
    const ui = document.getElementById('ui-datepicker-div');
    return !!(ui && ui.offsetParent !== null);
  }

  function debounce(fn, wait = 500) {
    let t, lastArgs, lastThis;
    const wrapped = function (...args) {
      lastArgs = args; lastThis = this;
      clearTimeout(t);
      t = setTimeout(() => { t = null; fn.apply(lastThis, lastArgs); }, wait);
    };
    wrapped.cancel = () => { clearTimeout(t); t = null; };
    wrapped.flush = () => { if (t) { clearTimeout(t); t = null; fn.apply(lastThis, lastArgs); } };
    return wrapped;
  }

  async function getCartEmirateFromCartJS() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      return cart?.attributes?.Emirate || '';
    } catch (e) {
      console.warn('[CartDelivery] Failed to read cart emirate', e);
      return '';
    }
  }

  (function fastHideSlotsPrePaint() {
    function dubaiHHmm() {
      try {
        const d = new Date(new Date().toLocaleString('en-US', { timeZone: CONFIG.TZ }));
        const pad = (n) => String(n).padStart(2, '0');
        return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
      } catch {
        const d = new Date();
        const pad = (n) => String(n).padStart(2, '0');
        return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
      }
    }
    const t = dubaiHHmm();
    const ge = (a, b) => a >= b, lt = (a, b) => a < b;
    const emSel = document.querySelector('#Emirate');
    const code = emSel?.value || 'DU';

    let todayBlocked = false;
    if (ge(t, CONFIG.GENERAL_CUTOFF)) todayBlocked = true;
    if (code === 'AI' && parseInt(t.slice(0, 2), 10) >= (CONFIG.EMIRATES.AI.blockAfterHour ?? 24)) todayBlocked = true;
    if (code === 'SH' && parseInt(t.slice(0, 2), 10) >= (CONFIG.EMIRATES.SH.blockAfterHour ?? 24)) todayBlocked = true;
    if (['FU', 'AJ', 'RK', 'UQ'].includes(code)) todayBlocked = true;

    let css = '';
    if (todayBlocked) {
      css += `#delivery-option{display:none!important}`;
      track('cd_today_blocked_prepaint', { reason: 'heuristic', emirate: code, time: t });
    } else {
      if (ge(t, CONFIG.TODAY_SLOTS.MORNING_HIDE_AT)) css += `.morning-delivery,.standard-delivery{display:none!important}`;
      if (ge(t, CONFIG.TODAY_SLOTS.EVENING_HIDE_AT)) css += `.evening-delivery{display:none!important}`;
      if (ge(t, CONFIG.TODAY_SLOTS.MIDNIGHT_HIDE_AT)) css += `.midnight-option{display:none!important}`;
      const expressWithin = ge(t, CONFIG.EXPRESS_WINDOW.start) && lt(t, CONFIG.EXPRESS_WINDOW.end);
      if (!expressWithin) css += `.today-only,.express{display:none!important}`;
    }

    if (css) {
      const tag = document.createElement('style');
      tag.id = 'fast-slot-hide';
      tag.textContent = css;
      document.head.appendChild(tag);
    }
  })();

  let __attrsPending = null;
  let __attrsSending = null;
  let updating = false;

  function mergeAttrs(base, next) { return Object.assign({}, base || {}, next || {}); }

  function updateAttrsCoalesced(obj) {
    __attrsPending = mergeAttrs(__attrsPending, obj);
    if (__attrsSending) return __attrsSending;

    __attrsSending = (async function sendLoop() {
      try {
        while (__attrsPending) {
          const payload = __attrsPending;
          __attrsPending = null;
          await updateAttrs(payload);
        }
      } finally {
        __attrsSending = null;
      }
    })();
    return __attrsSending;
  }

  updateAttrsCoalesced.flush = async function flushCoalesced() {
    if (__attrsSending) { try { await __attrsSending; } catch (e) {} return; }
    if (!__attrsPending) return;

    __attrsSending = (async function singleSend() {
      try {
        const payload = __attrsPending;
        __attrsPending = null;
        await updateAttrs(payload);
      } finally {
        __attrsSending = null;
      }
    })();

    try { await __attrsSending; } catch (e) {}
  };

  async function updateAttrs(obj) {
    const fd = new FormData();
    Object.entries(obj).forEach(([k, v]) => fd.append(`attributes[${k}]`, v == null ? '' : v));

    console.groupCollapsed('[CartDelivery] Cart Attribute Update');
    Object.entries(obj).forEach(([k, v]) => console.log(`${k}:`, v));
    console.groupEnd();

    while (updating) await new Promise((r) => setTimeout(r, 80));
    updating = true;

    try {
      const res = await fetch('/cart/update.js', { method: 'POST', body: fd });
      let json = {};
      try { json = await res.json(); } catch {}
      if (!res.ok) console.warn('[CartDelivery] Update non-OK:', res.status, json);
      else console.log('[CartDelivery] Server attributes echo:', json.attributes);
      return json;
    } catch (e) {
      console.warn('[CartDelivery] Update failed:', e);
    } finally {
      updating = false;
    }
  }

  async function purgeUnwantedAttributesOnce() {
    if (!UNWANTED_KEYS.length) return;
    const payload = {};
    UNWANTED_KEYS.forEach((k) => payload[k] = '');
    await updateAttrs(payload);
    console.log('[CartDelivery] Purged unwanted attributes:', UNWANTED_KEYS.join(', '));
  }

  function refreshDatepickerSafe(reason = '') {
    if (typeof $ === 'undefined' || !$.datepicker) return;
    try { $('#datepicker').datepicker('refresh'); } catch (e) {}
    if (reason) console.log('[CartDelivery][DP] refresh', reason);
  }

  function getCartCollectionState() {
    const items = document.querySelectorAll('.cart-item[data-collection-ids]');
    if (!items.length) return { hasItems: false, allValentine: false };
    let allValentine = true;
    items.forEach((item) => {
      const ids = (item.dataset.collectionIds || '').split(',').map((s) => s.trim()).filter(Boolean);
      const ok = ids.some((id) => CONFIG.CAMPAIGNS.VALENTINE.collectionIds.has(id));
      if (!ok) allValentine = false;
    });
    return { hasItems: true, allValentine };
  }

  /* ================= VALENTINE BLOCKER HELPERS (ADDED) ================= */
  
  function getEnhancedCartCollectionState() {
    const items = document.querySelectorAll('.cart-item[data-collection-ids]');
    
    if (!items.length) {
      return { 
        hasItems: false, 
        allValentine: false,
        hasValentine: false,
        hasNonValentine: false,
        isMixedCart: false
      };
    }

    let hasValentine = false;
    let hasNonValentine = false;

    items.forEach((item) => {
      const ids = (item.dataset.collectionIds || '').split(',').map((s) => s.trim()).filter(Boolean);
      const isValentineProduct = ids.some((id) => CONFIG.CAMPAIGNS.VALENTINE.collectionIds.has(id));
      
      if (isValentineProduct) {
        hasValentine = true;
      } else {
        hasNonValentine = true;
      }
    });

    return {
      hasItems: true,
      allValentine: hasValentine && !hasNonValentine,
      hasValentine: hasValentine,
      hasNonValentine: hasNonValentine,
      isMixedCart: hasValentine && hasNonValentine
    };
  }

  function wasRecentlyReloadedByValentineBlock() {
    const lastReload = sessionStorage.getItem('valentine-reload-triggered');
    if (!lastReload) return false;
    return (Date.now() - parseInt(lastReload, 10)) < 3000; // 3 second cooldown
  }

  function reloadPageForValentineBlock() {
    sessionStorage.setItem('valentine-reload-triggered', Date.now().toString());
    console.log('[Valentine Blocker] Reloading page - Feb 14th selected with incompatible cart...');
    setTimeout(() => window.location.reload(), 300);
  }

  /* ================= END VALENTINE BLOCKER HELPERS ================= */

  function isValentineActiveForSelection(dmy, emirateCode) {
    const V = CONFIG.CAMPAIGNS?.VALENTINE;
    return !!(V && V.enabled && V.dates.includes(dmy) && V.emirates.includes(emirateCode));
  }

  function applyValentineGateToHolidays() {
    const V = CONFIG.CAMPAIGNS?.VALENTINE;
    if (!V || !V.enabled) return;

    const state = getCartCollectionState();
    CONFIG.HOLIDAYS = CONFIG.HOLIDAYS.filter((d) => !V.dates.includes(d));

    if (state.hasItems && !state.allValentine) {
      V.dates.forEach((d) => { if (!CONFIG.HOLIDAYS.includes(d)) CONFIG.HOLIDAYS.push(d); });
    }
    refreshDatepickerSafe('valentine-gate');
  }

  function show(el) { if (el) { el.style.display = 'block'; el.classList.remove('hidetimerfirst'); } }
  function hide(el) { if (el) { el.style.display = 'none'; el.classList.add('hidetimerfirst'); } }

  function applyValentineDubaiVisibility(dmy) {
    const V = CONFIG.CAMPAIGNS?.VALENTINE;
    if (!V || !V.enabled) return false;

    const emirateCode = selectedEmirateCode();
    const active = isValentineActiveForSelection(dmy, emirateCode);

    const vWrap = q(V.optionSelector);
    if (vWrap) active ? show(vWrap) : hide(vWrap);

    if (emirateCode !== 'DU' || !active) return false;

    if (V.exclusiveInDubai) {
      const { morning, evening, express, midnight } = slots();
      if (morning) hide(morning);
      if (evening) hide(evening);
      if (express) hide(express);
      if (midnight) hide(midnight);
    }
    return true;
  }

  function applyEmirateOptionContainers() {
    const code = selectedEmirateCode();
    const dubai = q('.dubai-options');
    const auh = q('.abudhabi-options');
    const others = q('.other-emirates-options');
    [dubai, auh, others].forEach((el) => { if (el) el.classList.add('d-none'); });
    if (code === 'DU') dubai?.classList.remove('d-none');
    else if (code === 'AZ') auh?.classList.remove('d-none');
    else others?.classList.remove('d-none');
  }

  function applyTodayCutoffs() {
    const { morning, evening, express, midnight } = slots();
    const t = nowDubai().format('HH:mm');

    if (morning) (timeGE(t, CONFIG.TODAY_SLOTS.MORNING_HIDE_AT) ? (hide(morning), track('cd_slot_hide', { slot: 'morning', at: t })) : show(morning));
    if (evening) (timeGE(t, CONFIG.TODAY_SLOTS.EVENING_HIDE_AT) ? (hide(evening), track('cd_slot_hide', { slot: 'evening', at: t })) : show(evening));
    if (midnight) (timeGE(t, CONFIG.TODAY_SLOTS.MIDNIGHT_HIDE_AT) ? (hide(midnight), track('cd_slot_hide', { slot: 'midnight', at: t })) : show(midnight));

    if (express) {
      const within = timeGE(t, CONFIG.EXPRESS_WINDOW.start) && timeLT(t, CONFIG.EXPRESS_WINDOW.end);
      within ? show(express) : (hide(express), track('cd_slot_hide', { slot: 'express', at: t }));
    }
  }

  function applyFutureSlots() {
    const { morning, evening, express, midnight } = slots();
    if (morning) show(morning);
    if (express) hide(express);
    if (evening) hide(evening);
    if (midnight) hide(midnight);
    [express, evening, midnight].forEach((el) => { if (el) el.classList.add('hidetimerfirst'); });
  }

  function isTodayBlockedByEmirate(code, nowM) {
    const t = nowM.format('HH:mm');
    const h = parseInt(nowM.format('HH'), 10);

    if (timeGE(t, CONFIG.GENERAL_CUTOFF)) { track('cd_today_blocked', { reason: 'general_cutoff', at: t }); return true; }

    if (code === 'AZ') {
      const isSunday = nowM.format('dddd') === 'Sunday';
      const cutoff = isSunday ? CONFIG.EMIRATES.AZ.sundayCutoff : CONFIG.EMIRATES.AZ.otherCutoff;
      if (cutoff && timeGE(t, cutoff)) { track('cd_today_blocked', { reason: 'abu_dhabi_cutoff', isSunday, cutoff, at: t }); return true; }
    }

    if (code === 'AI' && h >= (CONFIG.EMIRATES.AI.blockAfterHour ?? 24)) { track('cd_today_blocked', { reason: 'al_ain_hour', at: t }); return true; }
    if (code === 'SH' && h >= (CONFIG.EMIRATES.SH.blockAfterHour ?? 24)) { track('cd_today_blocked', { reason: 'sharjah_hour', at: t }); return true; }
    if (['FU', 'AJ', 'RK', 'UQ'].includes(code)) { track('cd_today_blocked', { reason: 'other_emirate_policy', emirate: code }); return true; }
    return false;
  }

  function nextNonHolidayMoment(startM) {
    let m = startM.clone();
    for (let i = 0; i < 31; i++) {
      const dmy = fmtDMY(m);
      if (!isHoliday(dmy)) return m;
      m = m.add(1, 'day');
    }
    return startM.clone().add(1, 'day');
  }

  function computeNextActiveDate() {
    const now = nowDubai();
    const code = selectedEmirateCode();
    const todayBlocked = isTodayBlockedByEmirate(code, now);
    const todayIsHoliday = isHoliday(fmtDMY(now));

    if (!todayBlocked && !todayIsHoliday) return { m: now, label: 'Today' };

    const tomorrow = now.clone().add(1, 'day');
    if (!isHoliday(fmtDMY(tomorrow))) {
      track('cd_autoselect_date', { to: 'tomorrow', reason: todayBlocked ? 'blocked_today' : 'holiday_today' });
      return { m: tomorrow, label: 'Tomorrow' };
    }

    const nextWork = nextNonHolidayMoment(tomorrow);
    track('cd_autoselect_date', { to: 'calendar_future', reason: 'tomorrow_holiday', dmy: fmtDMY(nextWork) });
    return { m: nextWork, label: 'Selected' };
  }

  function enableTodayTab() {
    const todayA = q('.today-date');
    if (!todayA) return;
    todayA.removeAttribute('aria-disabled');
    todayA.removeAttribute('tabindex');
    todayA.classList.remove('disabled');
    todayA.style.pointerEvents = '';
    todayA.style.opacity = '';
    todayA.title = '';
  }

  function disableTodayTab() {
    const todayA = q('.today-date');
    if (!todayA) return;
    todayA.setAttribute('aria-disabled', 'true');
    todayA.setAttribute('tabindex', '-1');
    todayA.classList.add('disabled');
    todayA.style.pointerEvents = 'none';
    todayA.style.opacity = '0.55';
    todayA.title = 'Today delivery unavailable now';
  }

  function selectedTimeLabel() {
    const r = q('input[name="attributes[Delivery Time]"]:checked');
    if (!r) return '';
    const txt = r.closest('.form-check')?.querySelector('label')?.textContent?.trim();
    if (txt && /express/i.test(txt)) return 'Express';
    return txt || r.value || '';
  }

  function logCurrentState(label) {
    const code = selectedEmirateCode();
    const emirate = emirateName(code);
    const dmy = (q('#datepicker')?.value || '').trim();
    const dateNice = dmy.replace(/-/g, '/');
    const timeText = selectedTimeLabel();
    const suffix = timeText ? ` -> ${timeText}` : '';
    console.log(`Emirates: ${emirate} -> ${label} [${dateNice}]${suffix}`);
  }

  // ---------- NEW: watcher suppression gate ----------
  let __cdWatchSuppressUntil = 0;
  function suppressDateWatcher(ms = 900) { __cdWatchSuppressUntil = Date.now() + ms; }

  // ---------- NEW: de-dupe bursts on same date ----------
  let __cdLastDateSaved = '';
  let __cdLastDateSavedAt = 0;

  function installCalendarDayClickFallback() {
    if (window.__cdCalDayFallbackInstalled) return;
    window.__cdCalDayFallbackInstalled = true;
    if (typeof $ === 'undefined') return;

    $(document).off('click.cdCalDay', '#ui-datepicker-div td a');
    $(document).on('click.cdCalDay', '#ui-datepicker-div td a', function () {
      setTimeout(() => {
        const dp = document.querySelector('#datepicker');
        const v = (dp?.value || '').trim();
        if (!isDmy(v)) return;

        suppressDateWatcher(); // ✅ prevents watcher double-call
        console.log('[CartDelivery][CalendarSelect:fallbackClick]', v, '→ saving to cart...');
        Promise.resolve().then(() => syncDateAndLog(v));
      }, 0);
    });
  }

  function installDateValueWatcher() {
    if (window.__cdDateWatcherInstalled) return;
    window.__cdDateWatcherInstalled = true;

    let last = '';
    setInterval(() => {
      // ✅ ignore during suppression window
      if (Date.now() < __cdWatchSuppressUntil) return;
      // ✅ ignore while calendar overlay is open (prevents "calendar tab click" saving preview date)
      if (isDatepickerOpen()) return;

      const dp = document.querySelector('#datepicker');
      if (!dp) return;

      if (!__cdBootComplete) return;

      const v = (dp.value || '').trim();
      if (!isDmy(v)) return;
      if (v === last) return;

      last = v;
      console.log('[CartDelivery][DateChange:watch]', v, '→ saving to cart...');
      Promise.resolve().then(() => syncDateAndLog(v));
    }, 400);
  }

  function installDatepickerGuards() {
    if (typeof $ === 'undefined' || !$.datepicker) return;
    $('#datepicker').datepicker('option', 'beforeShowDay', function (dateJS) {
      const m = hasMomentTZ() ? moment(dateJS).tz(CONFIG.TZ) : moment(dateJS);
      const dmy = fmtDMY(m);
      const today = nowDubai();
      const tomorrow = nowDubai().add(1, 'day');

      if (dmy === fmtDMY(today) || dmy === fmtDMY(tomorrow)) return [false, 'disabled-date', 'Use the Today/Tomorrow buttons'];
      if (isHoliday(dmy)) return [false, 'holiday-date', 'Unavailable (Holiday)'];
      return [true, ''];
    });
  }

  function selectedTimeValue() {
    const r = q('input[name="attributes[Delivery Time]"]:checked');
    return r ? (r.value || '') : '';
  }

  function isOptionVisibleEl(el) {
    if (!el) return false;
    return el.style.display !== 'none' && !el.classList.contains('hidetimerfirst') && el.offsetParent !== null;
  }

  function autoPickFirstVisibleTime(reason = 'auto') {
    const dmy = (q('#datepicker')?.value || '').trim();
    const code = selectedEmirateCode();

    const V = CONFIG.CAMPAIGNS?.VALENTINE;
    if (V && isValentineActiveForSelection(dmy, code)) {
      const vWrap = q(V.optionSelector);
      const vInp = vWrap?.querySelector('input[type="radio"]');
      if (vWrap && isOptionVisibleEl(vWrap) && vInp) {
        vInp.checked = true;
        vInp.dispatchEvent(new Event('change', { bubbles: true }));
        console.log('[CartDelivery][AutoPick]', reason, '-> Valentine');
        return;
      }
    }

    const containers = ['.dubai-options', '.abudhabi-options', '.other-emirates-options']
      .map((s) => q(s))
      .filter(Boolean)
      .filter((el) => !el.classList.contains('d-none'));

    for (const c of containers) {
      const opt = qa('.form-check', c).find(isOptionVisibleEl);
      if (opt) {
        const inp = opt.querySelector('input[type="radio"]');
        if (inp) {
          inp.checked = true;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
    }
  }

  function applyDateChoice(dmy) {
    applyValentineGateToHolidays();

    const picked = parseDMY(dmy);
    const emirate = selectedEmirateCode();
    const today = nowDubai();
    const ctr = q('#delivery-option');

    if (isHoliday(dmy)) {
      if (ctr) ctr.style.display = 'none';
      track('cd_time_hidden', { reason: 'holiday', dmy });
      return;
    }

    if (picked.isValid && !picked.isValid()) {
      if (ctr) ctr.style.display = 'block';
      applyFutureSlots();
      return;
    }

    const campaignApplied = applyValentineDubaiVisibility(dmy);

    if (sameDay(picked, today)) {
      const blocked = isTodayBlockedByEmirate(emirate, today);
      if (ctr) ctr.style.display = blocked ? 'none' : 'block';
      if (!blocked && !campaignApplied) applyTodayCutoffs();
      return;
    }

    if (ctr) ctr.style.display = 'block';
    if (!campaignApplied) applyFutureSlots();
  }

    /* ================= TAB STATE SYNC (ADDED) ================= */
  function __cdSyncActiveTab(dmy) {
    try {
      const today = fmtDMY(nowDubai());
      const tomorrow = fmtDMY(nowDubai().add(1, 'day'));

      document.querySelectorAll('.tab-a').forEach(b =>
        b.classList.remove('active-a')
      );

      if (dmy === today) {
        document.querySelector('.today-date')?.classList.add('active-a');
      } else if (dmy === tomorrow) {
        document.querySelector('.tomorrow-date')?.classList.add('active-a');
      }
    } catch (e) {}
  }


  // ✅ UPDATED: UI applies instantly, network update is non-blocking, plus de-dupe bursts
  // ✅ ADDED: Valentine's Day validation with auto-reload
  async function syncDateAndLog(dmy) {
    const val = String(dmy || '').trim();
    if (!isDmy(val)) return;

    const nowMs = Date.now();
    if (val === __cdLastDateSaved && (nowMs - __cdLastDateSavedAt) < 800) return;
    __cdLastDateSaved = val;
    __cdLastDateSavedAt = nowMs;

    /* ================= VALENTINE BLOCKER LOGIC (ADDED) ================= */
    const isValentineDate = CONFIG.CAMPAIGNS?.VALENTINE?.dates?.includes(val);
    
    if (isValentineDate) {
      const cartState = getEnhancedCartCollectionState();
      
      console.log('[Valentine Blocker] Feb 14th selected - Cart analysis:', {
        date: val,
        allValentine: cartState.allValentine,
        hasNonValentine: cartState.hasNonValentine
      });

      // If cart has non-Valentine products -> reload page
      if (cartState.hasNonValentine && !wasRecentlyReloadedByValentineBlock()) {
        console.log('[Valentine Blocker] ✗ Incompatible cart - triggering reload');
        reloadPageForValentineBlock();
        return; // Exit - page will reload
      }
    }
    /* ================= END VALENTINE BLOCKER LOGIC ================= */

    applyDateChoice(val);
    autoPickFirstVisibleTime('date-change');
    __cdSyncActiveTab(val);

    const todayDmy = fmtDMY(nowDubai());
    const tomorrowDmy = fmtDMY(nowDubai().add(1, 'day'));
    const label = val === todayDmy ? 'Today' : (val === tomorrowDmy ? 'Tomorrow' : 'Selected');
    logCurrentState(label);

    void updateAttrs({ 'Delivery-Date': val }); // non-blocking
  }

  async function syncEmirateAndLog() {
    await updateAttrs({ 'Emirate': selectedEmirateCode() });

    const now = nowDubai();
    const code = selectedEmirateCode();

    if (!isTodayBlockedByEmirate(code, now) && !isHoliday(fmtDMY(now))) enableTodayTab();

    const dmy = q('#datepicker')?.value || fmtDMY(nowDubai());
    applyDateChoice(dmy);
    autoPickFirstVisibleTime('emirate-change');

    const todayDmy = fmtDMY(nowDubai());
    const tomorrowDmy = fmtDMY(nowDubai().add(1, 'day'));
    const label = dmy === todayDmy ? 'Today' : (dmy === tomorrowDmy ? 'Tomorrow' : 'Selected');
    logCurrentState(label);
  }

  async function syncTimeAndLog() {
    const r = q('input[name="attributes[Delivery Time]"]:checked');
    if (!r) return;
    const v = r.value || '';
    await updateAttrs({ 'Delivery-Time': v, 'Delivery Time': v });

    const dmy = q('#datepicker')?.value || fmtDMY(nowDubai());
    const todayDmy = fmtDMY(nowDubai());
    const tomorrowDmy = fmtDMY(nowDubai().add(1, 'day'));
    const label = dmy === todayDmy ? 'Today' : (dmy === tomorrowDmy ? 'Tomorrow' : 'Selected');
    logCurrentState(label);
  }

  function initEmirate() {
    const el = q('#Emirate');
    if (!el) return;
    el.addEventListener('change', syncEmirateAndLog);
  }

  function initTimeRadios() {
    qa('input[name="attributes[Delivery Time]"]').forEach((radio) => {
      radio.addEventListener('change', syncTimeAndLog);
    });
  }

  function initPhone() {
    const input = q('#sender-phone');
    if (!input) return;

    let iti = null;
    if (typeof window.intlTelInput === 'function') {
      iti = window.intlTelInput(input, {
        initialCountry: 'ae',
        separateDialCode: true,
        preferredCountries: ['ae', 'sa', 'kw', 'qa', 'bh', 'om'],
        utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.3/js/utils.js'
      });
    }

    const hidden = q('.receivers_phone_country_code');
    const sync = async () => {
      let dial = '';
      if (iti) {
        const d = iti.getSelectedCountryData();
        dial = d?.dialCode ? `+${d.dialCode}` : '';
        if (hidden) hidden.value = dial;
      }
      updateAttrsCoalesced({ 'sender-phone': input.value || '', 'receivers_phone_number_code': dial });
      console.log(`[CartDelivery] Phone set: ${dial} ${input.value || ''}`);
    };

    const syncDebounced = debounce(sync, 300);
    input.addEventListener('input', syncDebounced);
  }

  function initGreeting() {
    const el = q('#giftMessage')
      || q('textarea[name="attributes[Card Message]"]')
      || q('textarea[name="attributes[Greeting Message]"]')
      || q('textarea[name="attributes[Message]"]');
    if (!el) return;

    const sync = async () => {
      updateAttrsCoalesced({ 'Card Message': (el.value || '').trim() });
      console.log('[CartDelivery] Card Message updated (debounced).');
    };

    const syncDebounced = debounce(sync, 500);
    window.__greetingSync = syncDebounced;
    el.addEventListener('input', syncDebounced);
  }

  function initDatepickerAndTabs() {
    const dp = q('#datepicker');
    if (!dp || typeof $ === 'undefined' || !$.datepicker) {
      console.warn('[CartDelivery] Datepicker not found/loaded.');
      return;
    }

    q('.today-date')?.replaceWith(q('.today-date').cloneNode(true));
    q('.tomorrow-date')?.replaceWith(q('.tomorrow-date').cloneNode(true));
    q('.view-calendar')?.replaceWith(q('.view-calendar').cloneNode(true));

    const todayBtn = q('.today-date');
    const tomorrowBtn = q('.tomorrow-date');
    const calendarBtn = q('.view-calendar');

    $('#datepicker').datepicker({
      dateFormat: 'dd-mm-yy',
      minDate: 0,
      maxDate: '+30D',
      onSelect: async function (dateText, inst) {
        const dd = String(inst.selectedDay).padStart(2, '0');
        const mm = String(inst.selectedMonth + 1).padStart(2, '0');
        const yyyy = String(inst.selectedYear);
        const picked = `${dd}-${mm}-${yyyy}`;

        suppressDateWatcher(); // ✅
        console.log(`[CartDelivery][Calendar] You selected: ${dd}/${mm}/${yyyy} → saving to cart...`);
        await syncDateAndLog(picked);
        console.log(`[CartDelivery][Calendar] Saved Delivery-Date = ${dd}/${mm}/${yyyy}`);
      }
    });

    installDatepickerGuards();

    todayBtn?.addEventListener('click', async (e) => {
      e.preventDefault();
      const now = nowDubai();
      const code = selectedEmirateCode();

      q('.tab-a.active-a')?.classList.remove('active-a');
      todayBtn.classList.add('active-a');

      if (isTodayBlockedByEmirate(code, now) || isHoliday(fmtDMY(now))) {
        disableTodayTab();
        const t = now.clone().add(1, 'day');
        tomorrowBtn?.classList.add('active-a');
        todayBtn.classList.remove('active-a');

        suppressDateWatcher(); // ✅
        $('#datepicker').datepicker('setDate', t.toDate());
        if (dp) dp.value = fmtDMY(t);
        await syncDateAndLog(fmtDMY(t));
        return;
      }

      suppressDateWatcher(); // ✅
      $('#datepicker').datepicker('setDate', now.toDate());
      if (dp) dp.value = fmtDMY(now);
      await syncDateAndLog(fmtDMY(now));
    });

    tomorrowBtn?.addEventListener('click', async (e) => {
      e.preventDefault();

      q('.tab-a.active-a')?.classList.remove('active-a');
      tomorrowBtn.classList.add('active-a');

      const t = nowDubai().add(1, 'day');
      const dmy = fmtDMY(t);

      suppressDateWatcher(); // ✅
      $('#datepicker').datepicker('setDate', t.toDate());
      if (dp) dp.value = dmy;
      await syncDateAndLog(dmy);
    });

    calendarBtn?.addEventListener('click', (e) => {
      e.preventDefault();

      q('.tab-a.active-a')?.classList.remove('active-a');
      calendarBtn.classList.add('active-a');

      document.querySelectorAll('.tab').forEach((t) => t.classList.remove('tab-active'));
      document.querySelector('.tab[data-id="tab3"]')?.classList.add('tab-active');

      const t = nowDubai().add(CONFIG.CALENDAR_DEFAULT_OFFSET_DAYS, 'day');
      const dmy = fmtDMY(t);

      // ✅ critical: prevent watcher from auto-saving preview date
      suppressDateWatcher(1500);

      if (typeof $ !== 'undefined' && $.datepicker) {
        $('#datepicker').datepicker('setDate', t.toDate());
        $('#datepicker').datepicker('show');
      }
      if (dp) dp.value = dmy;

      console.log('[CartDelivery][Calendar] Opened calendar. Pick a date to save.');
    });
  }

  function installDatepickerGuards() {
    if (typeof $ === 'undefined' || !$.datepicker) return;
    $('#datepicker').datepicker('option', 'beforeShowDay', function (dateJS) {
      const m = hasMomentTZ() ? moment(dateJS).tz(CONFIG.TZ) : moment(dateJS);
      const dmy = fmtDMY(m);
      const today = nowDubai();
      const tomorrow = nowDubai().add(1, 'day');
      if (dmy === fmtDMY(today) || dmy === fmtDMY(tomorrow)) return [false, 'disabled-date', 'Use the Today/Tomorrow buttons'];
      if (isHoliday(dmy)) return [false, 'holiday-date', 'Unavailable (Holiday)'];
      return [true, ''];
    });
  }

  function isTimeOptionVisible(val) {
    var radios = document.querySelectorAll('input[name="attributes[Delivery Time]"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === val) {
        var opt = radios[i].closest('.form-check');
        return !!(opt && opt.style.display !== 'none' && !opt.classList.contains('hidetimerfirst') && opt.offsetParent !== null);
      }
    }
    return false;
  }

  async function validateAndCorrectDeliverySelection() {
    applyEmirateOptionContainers();
    applyValentineGateToHolidays();

    var code = selectedEmirateCode();
    if (!code) {
      var emSel = document.querySelector('#Emirate');
      if (emSel) emSel.value = 'DU';
      await updateAttrs({ 'Emirate': 'DU' });
      track('cd_fix', { field: 'Emirate', to: 'DU' });
    }

    var dp = document.querySelector('#datepicker');
    var hasDate = dp && dp.value;
    var now = nowDubai();
    var pickedM = hasDate ? parseDMY(dp.value) : null;

    var needRecompute =
      !hasDate ||
      (pickedM && pickedM.isValid && !pickedM.isValid()) ||
      (pickedM && isHoliday(fmtDMY(pickedM))) ||
      (pickedM && sameDay(pickedM, now) && isTodayBlockedByEmirate(selectedEmirateCode(), now));

    if (needRecompute) {
      var nextChoice = computeNextActiveDate();
      var nextDmy = fmtDMY(nextChoice.m);

      suppressDateWatcher(); // ✅ avoid watcher re-save
      if (typeof $ !== 'undefined' && $.datepicker) $('#datepicker').datepicker('setDate', nextChoice.m.toDate());
      if (dp) dp.value = nextDmy;

      void updateAttrs({ 'Delivery-Date': nextDmy });
      applyDateChoice(nextDmy);
      track('cd_fix', { field: 'Delivery-Date', to: nextDmy });
    } else {
      applyDateChoice(dp.value);
    }

    var checked = document.querySelector('input[name="attributes[Delivery Time]"]:checked');
    if (!checked || !isTimeOptionVisible(checked.value)) {
      if (checked) checked.checked = false;
      autoPickFirstVisibleTime('validate-fix');
      track('cd_fix', { field: 'Delivery Time', reason: 'hidden_or_missing' });
    }
  }

  function startTodayTicker() {
    function nextCutoffDelayMs() {
      const now = nowDubai();
      const targets = [
        CONFIG.TODAY_SLOTS.MORNING_HIDE_AT,
        CONFIG.TODAY_SLOTS.MIDNIGHT_HIDE_AT,
        CONFIG.TODAY_SLOTS.EVENING_HIDE_AT,
        CONFIG.EXPRESS_WINDOW.start,
        CONFIG.EXPRESS_WINDOW.end,
        CONFIG.GENERAL_CUTOFF
      ].map((s) => {
        const [H, M] = s.split(':').map(Number);
        const t = now.clone().hour(H).minute(M).second(0);
        if (t.isBefore(now)) t.add(1, 'day');
        return t;
      });
      const soonest = targets.sort((a, b) => a.valueOf() - b.valueOf())[0];
      return Math.min((soonest.valueOf() - now.valueOf()), 5 * 60 * 1000);
    }

    const applyIfToday = () => {
      const v = q('#datepicker')?.value;
      if (!v) return;

      const tNow = nowDubai().format('HH:mm');
      if (timeGE(tNow, CONFIG.GENERAL_CUTOFF)) disableTodayTab();

      const dm = parseDMY(v);
      if (dm?.isValid?.() && sameDay(dm, nowDubai())) applyTodayCutoffs();
    };

    setTimeout(() => {
      applyIfToday();
      setInterval(applyIfToday, 60000);
    }, nextCutoffDelayMs());
  }

  function setupNoMessageOption() {
    const aiContainer = document.querySelector('#aiCtrHere');
    if (!aiContainer) return;
    if (document.querySelector('#no-message')) return;

    const noMessageLabel = document.createElement('label');
    noMessageLabel.className = 'hdr';
    noMessageLabel.htmlFor = 'no-message';
    noMessageLabel.style.cursor = 'pointer';
    noMessageLabel.style.fontWeight = 'normal';
    noMessageLabel.innerHTML = `<input type='checkbox' id='no-message' value="1"> No Message Card Needed`;
    aiContainer.prepend(noMessageLabel);

    const noMessageCheckbox = document.querySelector('#no-message');
    noMessageCheckbox.addEventListener('change', async (e) => {
      const cartNote = document.querySelector('#CartNote');
      const aiSuggestCheckbox = document.querySelector('#ai-suggest');

      if (window.__greetingSync?.cancel) window.__greetingSync.cancel();

      if (e.target.checked) {
        const aiForm = document.querySelector('#ai-form');
        if (aiForm) aiForm.style.display = 'none';
        if (aiSuggestCheckbox) aiSuggestCheckbox.checked = false;

        if (cartNote) {
          cartNote.value = 'No Message';
          cartNote.setAttribute('disabled', 'disabled');
          cartNote.style.display = 'block';
        }
        await updateAttrs({ 'Card Message': 'No Message' });
        console.log('[CartDelivery] No Message selected');
      } else {
        if (cartNote) {
          cartNote.value = '';
          cartNote.removeAttribute('disabled');
          cartNote.style.display = 'block';
        }
        await updateAttrs({ 'Card Message': '' });
        console.log('[CartDelivery] Message field re-enabled');
      }
    });
  }

  (function attachUnifiedSelectionLogger() {
    if (window.__deliveryLoggerAttached__) return;
    window.__deliveryLoggerAttached__ = true;

    function dubaiDmy(offsetDays = 0) {
      if (typeof moment !== 'undefined' && moment.tz) {
        return moment.tz(CONFIG.TZ).add(offsetDays, 'day').format('DD-MM-YYYY');
      }
      const now = new Date(new Date().toLocaleString('en', { timeZone: CONFIG.TZ }));
      now.setDate(now.getDate() + offsetDays);
      const d = String(now.getDate()).padStart(2, '0');
      const m = String(now.getMonth() + 1).padStart(2, '0');
      const y = now.getFullYear();
      return `${d}-${m}-${y}`;
    }

    function emirateText() {
      const sel = document.querySelector('#Emirate');
      if (!sel) return '—';
      const opt = sel.options[sel.selectedIndex];
      return opt ? opt.text.trim() : '—';
    }

    function currentDmy() {
      const input = document.querySelector('#datepicker');
      if (input?.value) return input.value;
      const hidden = document.querySelector('input[name="attributes[Delivery-Date]"]');
      if (hidden?.value) return hidden.value;
      return '';
    }

    function dateLabel(dmy) {
      if (dmy === dubaiDmy(0)) return 'Today';
      if (dmy === dubaiDmy(1)) return 'Tomorrow';
      return dmy ? dmy.replace(/-/g, '/') : '—';
    }

    function timeLabel() {
      const checked = document.querySelector('input[name="attributes[Delivery Time]"]:checked');
      if (!checked) return '—';
      const lbl = document.querySelector(`label[for="${checked.id}"]`);
      return lbl ? lbl.textContent.trim() : (checked.value || '—');
    }

    function print(prefix = '') {
      const emir = emirateText();
      const dmy = currentDmy();
      const human = dmy.replace(/-/g, '/');
      const tag = dateLabel(dmy);
      const line = `Emirates: ${emir} -> ${tag} [${human}] -> ${timeLabel()}`;
      console.log(prefix ? `${prefix} ${line}` : line);
    }

    document.addEventListener('change', (e) => {
      if (e.target?.id === 'Emirate') setTimeout(() => print('[Emirate change]'), 250);
      if (e.target?.matches?.('input[name="attributes[Delivery Time]"]')) setTimeout(() => print('[Time change]'), 250);
      if (e.target?.id === 'datepicker') setTimeout(() => print('[Calendar change]'), 300);
    }, true);

    document.addEventListener('click', (e) => {
      const a = e.target.closest('.tab-a');
      if (!a) return;
      const id = a.getAttribute('data-id');
      const tag = id === 'tab1' ? '[Today click]' : id === 'tab2' ? '[Tomorrow click]' : '[Calendar tab click]';
      setTimeout(() => print(tag), 400);
    }, true);

    window.addEventListener('load', () => setTimeout(() => print('[Initial]'), 800));
  })();

  function isAttributesOnlyFormData(body) {
    try {
      if (!(body instanceof FormData)) return false;
      const keys = [];
      for (const [k] of body.entries()) keys.push(k);
      if (!keys.length) return false;
      return keys.every((k) => /^attributes\[/i.test(k));
    } catch (e) {
      return false;
    }
  }

  (function hookCartNetwork() {
    if (window.__cartNetworkHooked) return;
    window.__cartNetworkHooked = true;

    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
      const res = await originalFetch.apply(this, args);
      try {
        const url = args[0]?.toString?.() || '';
        const opts = args[1] || {};
        const body = opts.body;

        if (!/\/cart\/(add|change|update)\.js/i.test(url)) return res;
        if (/\/cart\/update\.js/i.test(url) && isAttributesOnlyFormData(body)) return res;

        console.log('[CartDelivery] Cart network update detected:', url);
        window.dispatchEvent(new Event('cart:updated'));
      } catch (e) {}
      return res;
    };

    const origOpen = XMLHttpRequest.prototype.open;
    const origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__cd_url = url;
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      const url = this.__cd_url || '';
      this.addEventListener('loadend', () => {
        try {
          if (!/\/cart\/(add|change|update)\.js/i.test(url)) return;
          if (/\/cart\/update\.js/i.test(url)) return;
          console.log('[CartDelivery] Cart XHR update detected:', url);
          window.dispatchEvent(new Event('cart:updated'));
        } catch (e) {}
      });
      return origSend.apply(this, arguments);
    };
  })();

  const reInitAfterCartUpdated = debounce(async () => {
    if (isDatepickerOpen()) {
      console.log('[CartDelivery] cart:updated skipped (datepicker open)');
      return;
    }

    applyValentineGateToHolidays();
    applyEmirateOptionContainers();

    initTimeRadios();
    initEmirate();
    initDatepickerAndTabs();
    installCalendarDayClickFallback();
    installDateValueWatcher();

    await validateAndCorrectDeliverySelection();
    console.log('[CartDelivery] Re-initialized after cart update');
  }, 250);

  window.addEventListener('cart:updated', reInitAfterCartUpdated);
  window.addEventListener('cart:updated', () => console.log('[CartDelivery][EVENT] cart:updated listener FIRED'));

  document.addEventListener('DOMContentLoaded', async () => {
    await purgeUnwantedAttributesOnce();

    const emSel = q('#Emirate');
    if (emSel) {
      const cartEmirate = await getCartEmirateFromCartJS();
      if (cartEmirate && emSel.value !== cartEmirate) {
        emSel.value = cartEmirate;
        track('cd_fix', { field: 'Emirate', source: 'cart', to: cartEmirate });
      }
    }

    initPhone();
    initGreeting();
    initTimeRadios();
    initEmirate();
    initDatepickerAndTabs();
    installCalendarDayClickFallback();
    installDateValueWatcher();
    setupNoMessageOption();

    applyValentineGateToHolidays();

    const choice = computeNextActiveDate();
    const chosenM = choice.m;
    const chosenDmy = fmtDMY(chosenM);

    const nowT = nowDubai().format('HH:mm');
    if (timeGE(nowT, CONFIG.GENERAL_CUTOFF) || isTodayBlockedByEmirate(selectedEmirateCode(), nowDubai()) || isHoliday(fmtDMY(nowDubai()))) {
      disableTodayTab();
    }

    suppressDateWatcher(); // ✅ avoid watcher saving the boot-set value
    if (typeof $ !== 'undefined' && $.datepicker) $('#datepicker').datepicker('setDate', chosenM.toDate());
    const dp = q('#datepicker');
    if (dp) dp.value = chosenDmy;

    applyEmirateOptionContainers();
    applyDateChoice(chosenDmy);
    autoPickFirstVisibleTime('initial');

        /* ================= FINAL BOOT COMMIT (ADDED) ================= */

    __cdSyncActiveTab(chosenDmy);

    // Mark system stable
    __cdBootComplete = true;

    // Reveal UI atomically
    document.documentElement.classList.remove('cd-booting');

    const bootStyle = document.getElementById('cd-boot-style');
    if (bootStyle) bootStyle.remove();


    await validateAndCorrectDeliverySelection();

    void updateAttrs({ 'Emirate': selectedEmirateCode(), 'Delivery-Date': chosenDmy });

    const fastTag = document.getElementById('fast-slot-hide');
    if (fastTag) fastTag.remove();

    startTodayTicker();

    try {
      var emirate = (document.querySelector('#Emirate') && document.querySelector('#Emirate').value) || '';
      var dateVal = (document.querySelector('#datepicker') && document.querySelector('#datepicker').value) || '';
      var timeVal = selectedTimeValue();
      var itemsCnt = (document.querySelectorAll('.cart-item') || []).length;
      var subtotalT = (document.querySelector('.totals__subtotal-value') || {}).innerText || '';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'cart_view',
        page_type: 'cart',
        cart_items_count: itemsCnt,
        cart_subtotal_text: subtotalT,
        emirate: emirate,
        delivery_date: dateVal,
        delivery_time: timeVal
      });
    } catch (e) {}

    (function wireBeginCheckoutEvent() {
      var btn = document.querySelector('.save-checkout');
      if (!btn) return;

      btn.addEventListener('click', function () {
        try {
          var emirate = (document.querySelector('#Emirate') && document.querySelector('#Emirate').value) || '';
          var dateVal = (document.querySelector('#datepicker') && document.querySelector('#datepicker').value) || '';
          var r = document.querySelector('input[name="attributes[Delivery Time]"]:checked');
          var timeVal = r ? r.value : '';
          var itemsCnt = (document.querySelectorAll('.cart-item') || []).length;

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'begin_checkoutv1',
            page_type: 'cart',
            emirate: emirate,
            delivery_date: dateVal,
            delivery_time: timeVal,
            cart_items_count: itemsCnt
          });
        } catch (e) {}

        if (updateAttrsCoalesced.flush) updateAttrsCoalesced.flush();
      });
    })();

    (function wireErrorTracking() {
      try {
        window.addEventListener('error', function (ev) {
          try {
            var msg = (ev && ev.message) ? String(ev.message).slice(0, 180) : '';
            var src = (ev && ev.filename) || '';
            var ln = (ev && ev.lineno) || 0;
            var cn = (ev && ev.colno) || 0;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'cart_js_error', message: msg, source: src, line: ln, col: cn });
          } catch (e) {}
        });

        window.addEventListener('unhandledrejection', function (ev) {
          try {
            var r = ev && ev.reason;
            var msg = '';
            if (r && typeof r === 'object') msg = r.message || JSON.stringify(r);
            else msg = String(r || '');
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'cart_js_error', message: String(msg).slice(0, 180), source: 'unhandledrejection' });
          } catch (e) {}
        });
      } catch (e) {}
    })();

    console.log('[CartDelivery] Ready.');
  });

  window.addEventListener('pageshow', function () {
    var dp = document.querySelector('#datepicker');
    if (dp && dp.value) applyDateChoice(dp.value);

    var checked = document.querySelector('input[name="attributes[Delivery Time]"]:checked');
    if (!checked || !isTimeOptionVisible(checked.value)) autoPickFirstVisibleTime('pageshow-fix');

    var now = nowDubai();
    var todayBlocked = isTodayBlockedByEmirate(selectedEmirateCode(), now) || isHoliday(fmtDMY(now));
    if (todayBlocked) disableTodayTab?.();

    Promise.resolve().then(validateAndCorrectDeliverySelection);
    track('cd_pageshow_revalidate', {});
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      validateAndCorrectDeliverySelection();
      track('cd_visibility_revalidate', {});
    } else if (document.visibilityState === 'hidden') {
      updateAttrsCoalesced.flush();
    }
  });

  window.addEventListener('pagehide', function () {
    updateAttrsCoalesced.flush();
  });

})(); // end main

/* ===== Cart item change reload guard (same as yours) ===== */
(function () {
  if (window.__CartReloadGuardInstalled__) return;
  window.__CartReloadGuardInstalled__ = true;

  let lastSignature = null;
  let reloadPending = false;

  function buildSignature(cart) {
    if (!cart || !Array.isArray(cart.items)) return 'empty';
    return cart.items.map(i => `${i.variant_id}:${i.quantity}`).sort().join('|');
  }

  function isDatepickerOpen() {
    const ui = document.getElementById('ui-datepicker-div');
    return !!(ui && ui.offsetParent !== null);
  }

  function hideDeliveryUI(reason = '') {
    const container =
      document.querySelector('#delivery-option') ||
      document.querySelector('.delivery-options-section');
    if (container) container.style.display = 'none';
    if (reason) console.log('[CartReload] Delivery UI hidden', reason);
  }

  async function storeBaseline() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      lastSignature = buildSignature(cart);
      console.log('[CartReload] Baseline signature stored');
    } catch (e) {
      console.warn('[CartReload] Failed to store baseline', e);
    }
  }

  async function onCartUpdated() {
    if (isDatepickerOpen()) return;
    if (reloadPending) return;

    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      const sig = buildSignature(cart);

      if (!lastSignature) {
        lastSignature = sig;
        console.log('[CartReload] Baseline signature stored (late)');
        return;
      }

      if (sig !== lastSignature) {
        console.log('[CartReload] Cart items changed → hiding delivery UI + refreshing page');
        lastSignature = sig;
        reloadPending = true;

        hideDeliveryUI('cart-item-change');
        setTimeout(() => window.location.reload(), 80);
      } else {
        console.log('[CartReload] Attribute-only change — no reload');
      }
    } catch (e) {
      console.warn('[CartReload] Failed to inspect cart', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', storeBaseline);
  } else {
    storeBaseline();
  }

  window.addEventListener('cart:updated', onCartUpdated);
})();

(function waitForFunction() {
  if (typeof window.applyValentineDubaiVisibility === 'function') {
    console.log('[Debug] applyValentineDubaiVisibility FOUND, applying override.');

    const VALENTINE_IDS = new Set(['268745867351','291787243607','266284007511']);

    function isCartNonValentineOnly() {
      const items = document.querySelectorAll('.cart-item[data-collection-ids]');
      if (!items.length) return false;

      const hasValentine = Array.from(items).some(item => {
        const ids = (item.dataset.collectionIds || '').split(',').map(s => s.trim());
        return ids.some(id => VALENTINE_IDS.has(id));
      });

      console.log('[Debug] Cart Valentine check:', { totalItems: items.length, hasValentine });
      return !hasValentine;
    }

    const originalFn = window.applyValentineDubaiVisibility;

    window.applyValentineDubaiVisibility = function(dmy) {
      const nonValentineCart = isCartNonValentineOnly();
      console.log('[Debug] applyValentineDubaiVisibility called:', { dmy, nonValentineCart });

      const result = originalFn(dmy);
      console.log('[Debug] originalFn returned:', result);

      if (dmy === '14-02-2026' && nonValentineCart) {
        console.log('[Debug] Feb 14 + non-Valentine cart → skipping Valentine popup');
        return false;
      }

      return result;
    };

    console.log('[Debug] Valentine override successfully applied.');

  } else {
    // Retry on next idle frame
    requestIdleCallback(waitForFunction);
  }
})();

(function () {
  const VALENTINE_DATE = '14-02-2026';
  const MSG = document.getElementById('very-options-msg');

  function shouldBlock() {
    const date =
      document.querySelector('#datepicker')?.value ||
      document.querySelector('[name="Delivery-Date"]')?.value;

    if (date !== VALENTINE_DATE) return false;

    const items = document.querySelectorAll('.cart-item[data-collection-ids]');
    if (!items.length) return false;

    // block if ANY non-valentine item exists
    return [...items].some(item => {
      const ids = (item.dataset.collectionIds || '').split(',');
      return !ids.some(id =>
        CONFIG.CAMPAIGNS.VALENTINE.collectionIds.has(id.trim())
      );
    });
  }

  document.querySelectorAll('#checkout, .save-checkout').forEach(btn => {
    btn.addEventListener('click', e => {
      if (!shouldBlock()) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      MSG?.classList.remove('d-none');

      // refresh ONLY here
      setTimeout(() => location.reload(), 100);
    }, true);
  });
})();


(function () {
  const TODAY_IS_13 = true; // logic already based on real date below

  function isToday13() {
    const d = new Date();
    return d.getDate() === 13;
  }

  function hasNonValentine() {
    const items = document.querySelectorAll('.cart-item[data-collection-ids]');
    if (!items.length) return false;

    return [...items].some(item => {
      const ids = (item.dataset.collectionIds || '').split(',');
      return !ids.some(id =>
        CONFIG.CAMPAIGNS.VALENTINE.collectionIds.has(id.trim())
      );
    });
  }

  function toggleTomorrowTab() {
    if (!isToday13() || !hasNonValentine()) return;

    /* 🔴 CHANGE THIS SELECTOR IF NEEDED */
    const tomorrowTab = document.querySelector(
      '[data-tab="tomorrow"], .delivery-tab.tomorrow'
    );

    if (!tomorrowTab) return;

    tomorrowTab.classList.add('disabled');
    tomorrowTab.style.pointerEvents = 'none';
    tomorrowTab.style.opacity = '0.4';
  }

  document.addEventListener('DOMContentLoaded', toggleTomorrowTab);
})();

(function () {

  function isToday13() {
    return new Date().getDate() === 13;
  }

  function isPureValentineCart() {
    const items = document.querySelectorAll('.cart-item[data-collection-ids]');
    if (!items.length) return false;

    return [...items].every(item => {
      const ids = (item.dataset.collectionIds || '').split(',');
      return ids.some(id =>
        CONFIG.CAMPAIGNS.VALENTINE.collectionIds.has(id.trim())
      );
    });
  }

  function handleTomorrowTab() {
    if (!isToday13()) return;
    if (isPureValentineCart()) return; // ✅ allow Valentine-only

    const tomorrowBtn = document.querySelector('.tomorrow-date');
    if (!tomorrowBtn) return;

    tomorrowBtn.classList.add('disabled');
    tomorrowBtn.style.pointerEvents = 'none';
    tomorrowBtn.style.opacity = '0.45';
    tomorrowBtn.setAttribute('aria-disabled', 'true');
    tomorrowBtn.setAttribute('tabindex', '-1');
  }

  document.addEventListener('DOMContentLoaded', handleTomorrowTab);

})();

// (function() {
//   console.log('[Valentine Tooltip] Script started');

//   const TOOLTIP_MSG = "Not available for Valentine’s Day. Only Valentine collection products are allowed.";

//   function isToday13() {
//     const today = new Date();
//     return today.getDate() === 13;
//   }

//   function hasNonValentineItems() {
//     const items = document.querySelectorAll('.cart-item[data-collection-ids]');
//     if (!items.length) return false;

//     return [...items].some(item => {
//       const ids = (item.dataset.collectionIds || '').split(',').map(s => s.trim());
//       return !ids.some(id => CONFIG.CAMPAIGNS.VALENTINE.collectionIds.has(id));
//     });
//   }

//   function addTooltip(tab) {
//     if (!tab || tab.dataset.tooltipAdded) return;

//     console.log('[Valentine Tooltip] Adding tooltip to tab:', tab);

//     tab.style.position = 'relative';
//     tab.style.opacity = '0.45';
//     tab.style.pointerEvents = 'none';
//     tab.setAttribute('aria-disabled', 'true');
//     tab.setAttribute('tabindex', '-1');

//     const info = document.createElement('span');
//     info.textContent = 'ℹ️';
//     info.style.cssText = `
//       position: absolute;
//       bottom: 4px;
//       right: 6px;
//       font-size: 14px;
//       cursor: pointer;
//       pointer-events: auto;
//       z-index: 5;
//     `;
//     info.title = TOOLTIP_MSG;
//     info.onclick = e => {
//       e.stopPropagation();
//       alert("Not available for Valentine’s Day.\nOnly Valentine collection products are available.\nVisit the Valentine collection now.");
//     };

//     tab.appendChild(info);
//     tab.dataset.tooltipAdded = 'true';
//   }

//   function applyTooltip() {
//     if (!isToday13() || !hasNonValentineItems()) return;

//     const tomorrowTab = document.querySelector('a.tomorrow-date');
//     if (tomorrowTab) {
//       addTooltip(tomorrowTab);
//     } else {
//       console.log('[Valentine Tooltip] Tomorrow tab not found yet');
//     }
//   }

//   // Run every 200ms to catch dynamic tab replacements
//   const interval = setInterval(applyTooltip, 200);

//   // Optional: stop after 10 seconds to avoid infinite loop
//   setTimeout(() => clearInterval(interval), 10000);
// })();

(function () {
  console.log('[Valentine Tooltip] Script started');

  const TOOLTIP_MSG =
    "Not available for Valentine’s Day. Only Valentine collection products are allowed.";
  const VALENTINE_IDS = new Set(['268745867351','291787243607','266284007511']);
  const ICON_COLOR = '#660A2D';

  /* ---------- CSS ---------- */
  const style = document.createElement('style');
  style.innerHTML = `
    li.valentine-tooltip-enabled {
      position: relative;
    }

    .valentine-tooltip-icon {
      position: absolute;
      top: 6px;
      right: 6px;
      font-size: 14px;
      font-style: italic;
      font-weight: 600;
      color: ${ICON_COLOR};
      user-select: none;
      pointer-events: none;
    }

    .valentine-tooltip-box {
      visibility: hidden;
      opacity: 0;
      width: 240px;
      background: #2c3e50;
      color: #fff;
      text-align: center;
      padding: 12px 16px;
      border-radius: 8px;
      font-size: 1.2rem;
      line-height: 1.4;
      position: absolute;
      z-index: 999;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 8px;
      box-shadow: 0 5px 20px rgba(0,0,0,.15);
      transition: opacity .2s;
      pointer-events: none;
    }

    li.valentine-tooltip-enabled:hover .valentine-tooltip-box {
      visibility: visible;
      opacity: 1;
    }

    .valentine-tooltip-box::after {
      content: '';
      position: absolute;
      top: -7px;
      left: 50%;
      transform: translateX(-50%);
      border: 7px solid transparent;
      border-bottom-color: #2c3e50;
    }
  `;
  document.head.appendChild(style);

  /* ---------- LOGIC ---------- */

  function isValentineDayRelevant() {
    const d = new Date().getDate();
    return d === 13 || d === 14;
  }

  function hasNonValentineItems() {
    const items = document.querySelectorAll('.cart-item[data-collection-ids]');
    return [...items].some(item => {
      const ids = (item.dataset.collectionIds || '').split(',');
      return !ids.some(id => VALENTINE_IDS.has(id.trim()));
    });
  }

 function applyTooltipOnce() {
  if (!hasNonValentineItems()) return;

  const today = new Date().getDate();
  let tabs = [];

  if (today === 13) {
    // 13th → disable TOMORROW only
    tabs = document.querySelectorAll('li:has(.tomorrow-date)');
  } 
  else if (today === 14) {
    // 14th → disable TODAY only
    tabs = document.querySelectorAll('li:has(.today-date)');  
  } 
  else {
    return;
  }

  tabs.forEach(li => {
    if (li.classList.contains('valentine-tooltip-enabled')) return;

    console.log('[Valentine Tooltip] Enabled on', li);

    li.classList.add('valentine-tooltip-enabled');

    const icon = document.createElement('span');
    icon.className = 'valentine-tooltip-icon';
    icon.textContent = 'i';

    const tooltip = document.createElement('div');
    tooltip.className = 'valentine-tooltip-box';
    tooltip.textContent = TOOLTIP_MSG;

    li.appendChild(icon);
    li.appendChild(tooltip);

    const btn = li.querySelector('a,button');
    if (btn) {
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.45';
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('tabindex', '-1');
    }
  });
}


  /* ---------- SAFE OBSERVER ---------- */
  const observer = new MutationObserver(() => {
    applyTooltipOnce();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  applyTooltipOnce();
})();
